import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            About <span className="purple">SimpleAdmin</span>
            </h1>
            <p className="home-about-body">
              SimpleAdmin is a Discord to Roblox Moderation Bot that allows users to send commands to and from games. It is run by Mountain Interactive and is scripted by Ash and Leo.
              <br />
              <br />SimpleAdmin is written in
              <i>
                <b className="purple"> Javascript, Typescript and LUA.</b>
              </i>
              <br />
              <br />
              Whenever possible, Mountain Interactive also applies its passion for developing products with <b className="purple">Node.js</b> to create
              <i>
                <b className="purple">
                  {" "}
                  Frameworks, Libraries and Tools
                </b>
              </i>
              &nbsp; that speak to the 
              <i>
                <b className="purple"> Roblox Platform</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND US ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with us
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/enterprises/mountaininteractive"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/MountainRBLX"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/company/mountaininteractive/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
